import { BookCopyIcon, UsersIcon } from 'lucide-react'
import { SCMark } from '../../assets'
import { ROUTES } from '../routes'

export const HEADER_LINKS = [
  {
    icon: <BookCopyIcon />,
    label: 'Courses',
    exact: true,
    href: ROUTES.home
  },
  {
    icon: <UsersIcon />,
    label: 'Community',
    href: ROUTES.community
  },
  {
    icon: <SCMark />,
    label: 'Social Curator',
    href: ROUTES.external.app,
    external: true
  }
]
